const isSupplementLabel = () => {
  return document.querySelector("#embed-code-token")?.dataset.labelType === "supplement";
};

const calculateEmbedCode = () => {
  const tokenElement = document.querySelector("#embed-code-token");
  if (!tokenElement) return;

  const token = tokenElement.className;
  let url;

  if (isSupplementLabel()) {
    url = `https://www.recipal.com/supplement_labels/${token}/embed.js`;
  } else {
    const formatInput = document.querySelector("input[name='embed_label_format']:checked");
    const ingredientsCheckbox = document.querySelector("#embed_ingredients");
    const allergensCheckbox = document.querySelector("#embed_allergens");

    const params = new URLSearchParams({
      label_format: formatInput?.value || "new_fda",
      ingredients: ingredientsCheckbox?.checked ? 1 : 0,
      allergens: allergensCheckbox?.checked ? 1 : 0,
    });
    url = `https://www.recipal.com/recipes/${token}/embed.js?${params.toString()}`;
  }

  const embedCode = `<script src="${url}" type="text/javascript"></script>`;
  const outputTextarea = document.querySelector("#embed-code-output");
  if (outputTextarea) {
    outputTextarea.value = embedCode;
    outputTextarea.select();
  }
};

const setEmbedOptions = () => {
  if (isSupplementLabel()) return;

  const labelFormat = document.querySelector(".label-preview")?.dataset.format;
  if (!labelFormat) return;

  let radioId;
  if (labelFormat.includes("fda") && !labelFormat.includes("old")) {
    radioId = "embed_label_format_new_fda";
  } else if (labelFormat.includes("canada")) {
    radioId = "embed_label_format_new_canada";
  } else {
    radioId = "embed_label_format_old_fda";
  }

  const radio = document.querySelector(`#${radioId}`);
  if (radio) radio.checked = true;
};

document.addEventListener("click", (event) => {
  if (!event.target.closest(".js-embed-label")) return;

  window.Modal.show("#embed-code-modal");
  setEmbedOptions();
  calculateEmbedCode();
});

document.addEventListener("click", (event) => {
  const target = event.target;
  if (
    target.name === "embed_label_format" ||
    target.id === "embed_ingredients" ||
    target.id === "embed_allergens"
  ) {
    calculateEmbedCode();
  }
});
